import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  margin: 30px 30px 0 0;
  overflow: hidden;
`;
